import { styled } from '@tigergraph/app-ui-lib/Theme';

export const Header = styled('h1', {
  fontSize: '18px',
  fontWeight: 600,
  fontFamily: 'Urbanist',
  lineHeight: '32px',
});
